import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {prlAuthentificationGuard} from '../../shared/services/prl-authentification-guard';
import {InfoComponent} from './components/info/info.component';
import {PrlPageGuard} from '../../shared/services/prl-page.guard';

const routes: Routes = [
    {
        path: 'info',
        component: InfoComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {pageName: 'Info Page'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrlInfoRoutingModule {
}
